import { render } from "./QuizEditorHeader.vue?vue&type=template&id=203d229f"
import script from "./QuizEditorHeader.vue?vue&type=script&lang=js"
export * from "./QuizEditorHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__